interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

function buildPages(current: number, total: number): (number | string)[] {
  const pages: (number | string)[] = [];
  if (total <= 7) {
    for (let i = 1; i <= total; i += 1) pages.push(i);
    return pages;
  }
  pages.push(1);
  if (current > 3) pages.push("...");
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (current < total - 2) pages.push("...");
  pages.push(total);
  return pages;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;
  const pages = buildPages(current, total);

  const baseBtn =
    "min-w-9 h-9 px-2 rounded-md text-sm flex items-center justify-center transition-colors";

  return (
    <nav className="flex items-center justify-center gap-2 flex-wrap" aria-label="分页">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className={`${baseBtn} border border-background-300 text-foreground-600 hover:border-primary-400 hover:text-primary-600 cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap`}
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
      </button>

      {pages.map((p, idx) =>
        typeof p === "number" ? (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={`${baseBtn} cursor-pointer ${
              p === current
                ? "bg-primary-500 text-background-50"
                : "border border-background-300 text-foreground-600 hover:border-primary-400 hover:text-primary-600"
            }`}
          >
            {p}
          </button>
        ) : (
          <span key={`gap-${idx}`} className="px-1 text-foreground-400">
            …
          </span>
        )
      )}

      <button
        type="button"
        disabled={current === total}
        onClick={() => onChange(current + 1)}
        className={`${baseBtn} border border-background-300 text-foreground-600 hover:border-primary-400 hover:text-primary-600 cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap`}
      >
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </nav>
  );
}